import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity } from '../../../services/servicio-formato-asistencial.service';
import { FechaService } from '../../../services/utils/fecha.service';
import { EntidadEmpresarialEntity } from '../../../services/servicio-entidad.service';

@Component({
  selector: 'app-encabezado-formato',
  templateUrl: './encabezado-formato.component.html',
  styleUrls: ['./encabezado-formato.component.css']
})
export class EncabezadoFormatoComponent implements OnInit, OnChanges {

  @Input() public data: FormatoAsistencialEntity;
  @Input() public entidad: EntidadEmpresarialEntity;
  @Input() public filtros: FiltrosFormatoAsistencialEntity;
  fechaImpresion: Date;

  constructor( private servicioFecha: FechaService) { }

  ngOnChanges() {
    this.fechaImpresion = new Date();
  }

  ngOnInit() {
    this.fechaImpresion = new Date();
  }

  // Auxiliares Afiliado

  getNombreAfiliado() {
    const primerNombre = this.data.afiliado.primerNombre;
    const segundoNombre = this.data.afiliado.segundoNombre ? ' ' + this.data.afiliado.segundoNombre : '';
    const primerApellido = this.data.afiliado.primerApellido ? ' ' + this.data.afiliado.primerApellido : '';
    const segundoApellido = this.data.afiliado.segundoApellido ? ' ' + this.data.afiliado.segundoApellido : '';
    return `${primerNombre}${segundoNombre}${primerApellido}${segundoApellido}`;
  }

  getEdad() {
    const edad = this.data.afiliado.edad;
    return `${edad.anos} Año(s) - ${edad.meses} Mes(es)`;
  }

  getIdentificacion() {
    return this.data.afiliado.tipoDocumento + '-' + this.data.afiliado.numeroIdentificacion;
  }

  getGenero() {
    const codigo = this.data.afiliado.codigoSexo.trim().toLowerCase();
    switch (codigo) {
      case 'm': return 'masculino';
      case 'f': return 'femenino';
      case 'a': return 'ambos';
      default: return '';
    }
  }

  getTitleFormato(){
    return this.data.type === 'HC' ? 'Historia' : (this.data.type === 'EV' ? 'Evolución' : 'Formato');
  }

  // Auxiliares entidad
  getNit() {
    return this.entidad.identificacionTributaria + '-' + this.entidad.digitoVerificacion;
  }

  // Auxiliares adicional
  getNumeroDocumento() {
    return this.data.transaccion.prefijo + '-' + this.data.transaccion.consecutivo;
  }

  isResponsables() {
    return this.filtros && this.filtros.parametroSimens && this.filtros.parametroSimens.activaResponsable;
  }

  getSede() {
    const sedeLarga = this.data && this.data.sedePuntoAtencion && this.data.sedePuntoAtencion.sede ? this.data.sedePuntoAtencion.sede.descripcionLarga : '';
    const sedeCorta = this.data && this.data.sedePuntoAtencion && this.data.sedePuntoAtencion.sede ? this.data.sedePuntoAtencion.sede.descripcionCorta : '';
    return sedeLarga ? sedeLarga : sedeCorta;
  }

}
